import { render, staticRenderFns } from "./trafficPage.vue?vue&type=template&id=94078e10&scoped=true"
import script from "./trafficPage.vue?vue&type=script&lang=js"
export * from "./trafficPage.vue?vue&type=script&lang=js"
import style0 from "./trafficPage.vue?vue&type=style&index=0&id=94078e10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94078e10",
  null
  
)

export default component.exports